<template>
    <div class="animated fadeIn">
        <b-card>

            <button class="btn btn-primary" @click="createNewPayments(0)">Создать новую ведомость для текущего месяца</button>
            &nbsp;
            <button class="btn btn-primary" @click="createNewPayments(1)">Создать новую ведомость для предыдущего месяца</button>

            <br><br>

            <table class="table table-bordered table-striped table-hover table-sm">
                <tr>
                    <th>Месяц</th>
                    <th>Версия</th>
                    <th>Статус</th>
                    <th>Комментарий</th>
                    <th><i class="fa fa-edit enlarged-icon"></i></th>
                    <th><i class="fa fa-copy enlarged-icon"></i></th>
                    <th><i class="fa fa-print enlarged-icon"></i></th>
                </tr>
                <tr v-for="document in documents" v-bind:key="document.id">
                    <td>{{ stripDateMon(document.mon) }}</td>
                    <td>{{ document.no }}</td>
                    <td>{{ document.ok ? 'утверждено':'создано' }}</td>
                    <td>{{ document.comment }}</td>
                    <td class="center color-success">
                        <a href="#" @click.prevent="editDocument(document)"><i class="fa fa-edit" title="Изменить документ" v-if="!document.ok"></i></a>
                        <a href="#" @click.prevent="editDocument(document)"><i class="fa fa-file" title="Посмотреть документ" v-if="document.ok"></i></a>
                    </td>
                    <td class="center color-primary"><a href="#"  @click.prevent="cloneDocument(document)" ><i class="fa fa-copy can-be-clicked enlarged-icon"title="Создать новую ревизию" v-if="document.ok"></i></a></td>
                    <td class="center color-primary"><a href="#" @click.prevent="doPrint(document.id)" ><i class="fa fa-print can-be-clicked enlarged-icon" title="Печатать документ" v-if="document.ok"></i></a></td>
                </tr>
            </table>

            <template v-if="documentOnEdit && loadFinised">
                <b-modal :title="'Агентское вознаграждение за '+ stripDateMon(documentOnEdit.mon) + ( documentOnEdit.no? 'версия ' + documentOnEdit.no : '')" class="modal-primary" size="xl" centered  v-model="editModalOpened" ok-variant="primary">

                    <table style="width:100%;" class="table table-bordered table-sm table-hover">
                        <tr>
                            <th rowspan="2">Агент</th>
                            <th colspan="6">Продажа</th>
                            <th colspan="2">Вознаграждение</th>
                            <th rowspan="2">Доплата/штраф</th>
                            <th rowspan="2">Сумма к оплате</th>
                            <th rowspan="2">Комментарий</th>
                        </tr>
                        <tr>
                            <th>Путевки</th>
                            <th>Скидка</th>
                            <th>Агентское</th>
                            <th>За минусом скидки</th>
                            <th>Корректировка</th>
                            <th>Итог</th>
                            <!--th>Базовый %</th-->
                            <th>Бонус %</th>
                            <!--th>Итоговый %</th-->
                            <th>Сумма</th>
                        </tr>

                        <tr v-for="fee in fees" v-bind:key="fee.id">
                            <td class="td-10">{{ fee.user_lastname }} {{ fee.user_firstname }}</td>

                            <td class="td-6 text-right">{{formatPriceKop(fee.sales_amount)}}₽
                                <template v-if="(documentOnEdit.no>1)&&(fee.sales_amount_pr!=fee.sales_amount)"><br><span style="color:lightgrey">{{formatPriceKop(fee.sales_amount_pr)}}₽</span></template>
                            </td>

                            <td class="td-6 text-right">{{formatPriceKop(fee.discount)}}₽
                                <template v-if="(documentOnEdit.no>1)&&(fee.discount_pr!=fee.discount)"><br><span style="color:lightgrey">{{formatPriceKop(fee.discount_pr)}}₽</span></template>
                            </td>

                            <td class="td-6 text-right">{{formatPriceKop(fee.agency_fee)}}₽
                                <template v-if="(documentOnEdit.no>1)&&(fee.agency_fee_pr!=fee.agency_fee)"><br><span style="color:lightgrey">{{formatPriceKop(fee.agency_fee_pr)}}₽</span></template>
                            </td>

                            <td class="td-6 text-right">{{formatPriceKop(fee.agency_fee - fee.discount)}}₽
                                <template v-if="(documentOnEdit.no>1)&&(fee.agency_fee_pr-fee.discount_pr!=fee.agency_fee-fee.discount)">
                                    <br><span style="color:lightgrey">{{formatPriceKop(fee.agency_fee_pr-fee.discount_pr)}}₽</span></template>
                            </td>

                            <td class="td-6 text-right">
                                <currency-input
                                    v-model.number="fee.sales_correction"
                                    :id="'sales_correction'+fee.id"
                                    :datavvas="'Сумма корректировки'"
                                    :cls="'form-control form-control-sm input-summa'"
                                    @input="fee.sales_total = fee.sales_amount + fee.sales_correction"
                                    v-if="!documentOnEdit.ok"
                                ></currency-input>
                                <template v-if="documentOnEdit.ok">{{formatPriceKop(fee.sales_correction)}}₽</template>
                            </td>

                            <td class="td-6 text-right">{{ formatPriceKop(fee.sales_total) }}₽<template v-if="(documentOnEdit.no>1)&&(fee.sales_total_pr!=fee.sales_total)">
                                <br><span style="color:lightgrey">{{formatPriceKop(fee.sales_total_pr)}}₽</span></template>

                                <!--td class="td-3 text-right">{{ fee.base_rate }}%</td-->
                            <td class="td-3 text-right">
                                <input type="text" v-model.number="fee.bonus_rate"
                                       v-validate="{integer:true,required:true, min_value:0, max_value:100}"
                                       class="form-control form-control-sm  input-summa"
                                       @input="fee.result_rate = fee.base_rate + fee.bonus_rate"
                                       v-if="!documentOnEdit.ok">
                                <template v-if="documentOnEdit.ok">{{fee.bonus_rate}}%</template>
                            </td>
                            <!--td class="td-3 text-right">{{ fee.result_rate }}%</td-->
                            <td class="td-6 text-right">{{ formatPriceKop(fee.total_value) }}₽<template v-if="(documentOnEdit.no>1)&&(fee.total_value_pr!=fee.total_value)">
                                <br><span style="color:lightgrey">{{formatPriceKop(fee.total_value_pr)}}₽</span></template>
                            </td>
                            <td class="td-6 text-right">
                                <currency-input
                                    v-model.number="fee.bonus_penalty"
                                    :id="'bonus_penalty'+fee.id"
                                    :datavvas="'Сумма бонуса/штрафа'"
                                    :cls="'form-control form-control-sm input-summa'"
                                    v-if="!documentOnEdit.ok"
                                ></currency-input>
                                <template v-if="documentOnEdit.ok">{{formatPriceKop(fee.bonus_penalty)}}₽</template>
                            </td>
                            <td class="td-6 text-right">{{ formatPriceKop(fee.payment) }}₽<template v-if="(documentOnEdit.no>1)&&(fee.payment_pr!=fee.payment)">
                                <br><span style="color:lightgrey">{{formatPriceKop(fee.payment_pr)}}₽</span></template>
                            </td>
                            <td class="td-10">
                                <input type="text" v-model="fee.bonus_penalty_reason" class="form-control form-control-sm"
                                       v-validate="{ max:200 }"
                                       v-if="!documentOnEdit.ok">
                                <template v-if="documentOnEdit.ok">{{formatPriceKop(fee.bonus_penalty_reason)}}</template>
                            </td>
                        </tr>
                    </table>

                    <b-form-group label="Комментарий к документу">
                        <input class="form-control" type="text" v-model="documentOnEdit.comment"
                               v-validate="{ required:true,max:200 }" name="comment"  data-vv-as="'Комментарий'" v-if="!documentOnEdit.ok">
                    </b-form-group>

                    <div class="form-group">
                        <b-button-group>
                            <button @click="onCancel" class="btn btn-secondary">Закрыть</button>
                            <template>
                                <button @click="onSave" class="btn btn-primary">Сохранить</button>
                            </template>
                            <template>
                                <button @click="onApply" class="btn btn-primary">Применить</button>
                            </template>
                            <template>
                                <button @click="onApprove" class="btn btn-primary">Утвердить</button>
                            </template>
                            <template>
                                <button @click="onPrint" class="btn btn-secondary">Печать</button>
                            </template>
                        </b-button-group>
                    </div>

                </b-modal>
            </template>

            <div><a :href="report_url">{{report_url}}</a></div>

            <div v-html="report_text"></div>

        </b-card>
    </div>
</template>

<script>
    import { functions } from '@/functions.js';
    import CurrencyInput from '@/components/CurrencyInput'


    export default {
        name: 'NsbAgencyFees',
        mixins: [functions],
        components: {
            CurrencyInput
        },
        data: function () {
            return {
                documents:[],
                latest:0,
                editModalOpened:false,
                fees:[],
                documentOnEdit:null,
                documentOnEditFromList:null,
                report_text: '',
                report_url: '',
            };
        },

        methods: {
            getDocuments: function () {
                this.httpPrepare();
                this.$http.get(this.apiurl('agentfee')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.documents = response.payload;
                }, this.httpError);
            },

            getDocument(document_id) {
                this.loadFinised = false;
                this.fees = [];

                this.httpPrepare();
                this.$http.get(this.apiurl('agentfee/' + document_id)).then(function (response) {
                    response = this.httpSuccess(response);
                    console.log(response.payload);
                    this.documentOnEdit = response.payload.document;
                    this.fees = response.payload.fees;
                    this.loadFinised = true;
                }, this.httpError);
            },

            createNewPayments: function(month) {
                this.httpPrepare();
                this.$http.post(this.apiurl('agentfee/create-last-month/'+month)).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success') {
                        this.documents.unshift(response.payload);
                        this.latest = response.payload.id;
                    }
                    else {
                        alert(response.error);
                        console.log(response.error);
                    }
                }, this.httpError);
            },

            editDocument:function (document) {
                this.documentOnEditFromList = document;
                this.getDocument(document.id);
                this.editModalOpened = true;
            },

            cloneDocument:function (document) {
                this.httpPrepare();
                this.$http.post(this.apiurl('agentfee/create/' + this.stripDate(document.mon))).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success') {
                        this.documents.unshift(response.payload);
                        this.latest = response.payload.id;
                    }
                    else {
                        alert(response.error);
                        console.log(response.error);
                    }
                }, this.httpError);
            },

            onCancel: function () {
                this.editModalOpened = false;
                this.documentOnEditFromList = null;
                this.documentOnEdit = null;
            },

            preSave:function () {
            },

            onSave :function () {
                this.preSave();
                console.log('onApply');
                this.httpPrepare();
                this.$http.put(this.apiurl('agentfee/' + this.documentOnEdit.id + '/save'), {document:this.documentOnEdit,fees:this.fees}).then(function (response) {
                    response = this.httpSuccess(response);
                    this.editModalOpened = false;
                    this.documentOnEditFromList.ok = this.documentOnEdit.ok;
                    this.documentOnEditFromList.comment = this.documentOnEdit.comment;
                    this.documentOnEditFromList = null;
                    this.documentOnEdit = null;
                }, this.httpError);
            },

            onApply :function () {
                this.preSave();
                console.log('onApply');
                this.httpPrepare();
                this.$http.put(this.apiurl('agentfee/' + this.documentOnEdit.id + '/save'), {document:this.documentOnEdit,fees:this.fees}).then(function (response) {
                    response = this.httpSuccess(response);
                    this.documentOnEdit = response.payload.document;
                    this.fees = response.payload.fees;
                    this.documentSaved();
                    this.documentOnEditFromList.ok = this.documentOnEdit.ok;
                    this.documentOnEditFromList.comment = this.documentOnEdit.comment;
                }, this.httpError);
            },

            onApprove :function () {
                this.preSave();
                console.log('onApprove');
                this.httpPrepare();
                this.$http.put(this.apiurl('agentfee/' + this.documentOnEdit.id + '/approve'), {document:this.documentOnEdit,fees:this.fees}).then(function (response) {
                    response = this.httpSuccess(response);
                    console.log('onApprove - OK');
                    this.documentOnEdit = response.payload.document;
                    this.fees = response.payload.fees;
                    this.documentOnEditFromList.ok = this.documentOnEdit.ok;
                    this.documentOnEditFromList.comment = this.documentOnEdit.comment;
                }, this.httpError);
            },
            onPrint:function () {
                this.doPrint(this.documentOnEdit.id);
            },
            doPrint:function (doc_id) {
                this.httpPrepare();
                this.$http.post(this.apiurl('report/create'), {doc_id:doc_id, report_type:'T_AG_BUH_AGENT_FEE'}).then(function (response) {
                    response = this.httpSuccess(response);
                    this.report_text =  response.report_text;
                    this.report_url =  response.report_url;
                }, this.httpError);
            },
        },

        created: function () {
            this.getDocuments();
        },

        notifications: {
                documentSaved: {
                    type: 'success',
                    title: 'Данные сохранены',
                    message: 'Ведомость расчета агентского вознаграждения сохранена'
                },
                documentSaved: {
                    type: 'success',
                    title: 'Расчет выполнен',
                    message: 'Pасчета агентского вознаграждения выполнен'
                },
            }
    };
</script>

<style lang="scss"></style>
